export default __webpack_public_path__ + "static/underline-19-mobile-46bc24fa48e94b34bdced58c64eb3fff.svg";